import React from 'react';
import Icon from './Icon';

// Keeps one broken screen from blanking the whole app: shows what went wrong
// with a way to retry. Give it a key that changes on navigation so moving to
// another page clears the error.
class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { error: null };
    }

    static getDerivedStateFromError(error) {
        return { error };
    }

    componentDidCatch(error, info) {
        console.error('Screen crashed:', error, info?.componentStack);
    }

    render() {
        const { error } = this.state;
        if (!error) return this.props.children;
        return (
            <div className="ls-card" role="alert" style={{ alignItems: 'flex-start', maxWidth: 640 }}>
                <div className="ls-row" style={{ gap: 10 }}>
                    <Icon name="error" size={22} color="var(--danger-text)" />
                    <div className="ls-card-title">This page hit a problem</div>
                </div>
                <div className="ls-empty">
                    Something on this page failed to load. Your work elsewhere is safe. Try again, and if it keeps happening, send us the message below.
                </div>
                <code className="ls-chip" style={{ whiteSpace: 'pre-wrap', fontSize: 12 }}>{String(error?.message || error)}</code>
                <div className="ls-actions">
                    <button type="button" className="ls-btn ls-btn-primary" onClick={() => this.setState({ error: null })}>
                        <Icon name="refresh" size={18} />Try again
                    </button>
                    <button type="button" className="ls-btn ls-btn-secondary" onClick={() => window.location.reload()}>
                        Reload the app
                    </button>
                </div>
            </div>
        );
    }
}

export default ErrorBoundary;
